import { useEffect } from 'react';
/** Debounced effect */
export function useDebouncedEffect(effect, deps, delay) {
    useEffect(function () {
        var destructor;
        var timeout = setTimeout(function () {
            destructor = effect();
        }, delay);
        return function () {
            clearTimeout(timeout);
            destructor === null || destructor === void 0 ? void 0 : destructor();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
//# sourceMappingURL=useDebouncedEffect.js.map